import {Injectable, Injector} from "@angular/core";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "./custom-object-type-search.model";

@Injectable()
export class ProductLineCustomObjectTypeSearchModel extends CustomObjectTypeSearchModel {
    constructor(injector: Injector) {
        super(injector);
        this.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.PRODUCT_LINE;
    }

    override getResource(): string {
        return "custom-product-group-type";
    }
}
